import type { MailboxInfo } from 'owa-client-types';
import getShowDaylightSavingTimeViewCloudSetting from '../selectors/getShowDaylightSavingTimeViewCloudSetting';

const SHOW_DAYLIGHT_SAVING_TIME_VIEW_FALLBACK = true;

/**
 * Gets the ocs or default value for the show daylight saving time view option
 * The default is true to show the extra time bars for daylight saving time
 * @param mailboxInfo the mailbox info
 */
export default function getShowDaylightSavingTimeView(mailboxInfo: MailboxInfo): boolean {
    const showDaylightSavingTimeView = getShowDaylightSavingTimeViewCloudSetting(mailboxInfo);
    return showDaylightSavingTimeView != null
        ? showDaylightSavingTimeView
        : SHOW_DAYLIGHT_SAVING_TIME_VIEW_FALLBACK;
}
